var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",class:['scroll_container', { hide_scroll: _vm.hiddeScroll }]},[_c('div',{ref:"content",staticClass:"mouse-wheel-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }